import { useState, useEffect } from 'react';
// @mui
import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
} from '@mui/material';
// components
import Scrollbar from '../../components/Scrollbar';
import {
  TrackingRecordTableRow,
} from './';
import {
  DailyDoneTodoDialog,
} from '../todo';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'date', label: '날짜', align: 'left', width: 180 },
  { id: 'time', label: '출퇴근 시간', align: 'center', width: 240 },
  { id: 'duration', label: '근무 시간', align: 'left', width: 200 },
];

export default function TrackingRecordTable({ lastId, trackingData, openFromAlimtalk }) {
  const [selectedRow, setSelectedRow] = useState(null);
  const [isOpenDoneTodoDialog, setIsOpenDoneTodoDialog] = useState(false);

  const openDoneTodoDialog = (row) => {
    setSelectedRow(row);
    setIsOpenDoneTodoDialog(true);
  };

  const closeDoneTodoDialog = () => {
    setSelectedRow(null);
    setIsOpenDoneTodoDialog(false);
  };

  useEffect(() => {
    if (openFromAlimtalk) {
      const todoItem = trackingData.find((item) => String(item.id) === String(openFromAlimtalk));
      if (todoItem) openDoneTodoDialog(todoItem);
    }
  }, [openFromAlimtalk]);

  return (
    <Scrollbar>
      <TableContainer sx={{ py: 2, px: 1 }}>
      <Table size={'medium'}>
        <TrackingRecordTableHead
          headLabel={TABLE_HEAD}
          sx={{ whiteSpace: 'nowrap' }}
        />
        <TableBody>
          {trackingData && trackingData.map((row) => (
            <TrackingRecordTableRow
              key={row.id}
              row={row}
              lastId={lastId}
              onClick={() => openDoneTodoDialog(row)}
            />
          ))}
        </TableBody>
      </Table>
      </TableContainer>
      <DailyDoneTodoDialog
        isOpen={isOpenDoneTodoDialog}
        closeDialog={closeDoneTodoDialog}
        row={selectedRow}
      />
    </Scrollbar>
  )
}

function TrackingRecordTableHead({
  headLabel,
  sx,
}) {
  return (
    <TableHead sx={sx}>
      <TableRow>
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align || 'left'}
            sx={{ width: headCell.width, minWidth: headCell.minWidth }}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
